import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import swal from 'sweetalert';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEfectuarVoto, fetchVerificarVoto, selectHaVotado } from '../../redux/Encuestas/EncuestasSlice';

export const VotarCard = ({participante, usuario, haVotado, usuarioVotado, criteriosHabilitado = false, setOpenVotacionCriterios}) => {

    const dispatch = useDispatch();

    const {
        participanteId,
        nombres,
        apellidos,
        encuestaId,
        areaOrganizacional,
        foto
    } = participante
    
    
    const fotoEmpleado = useMemo(() => {
        return `${foto}?cacheBust=${new Date().getTime()}`;
    }, [foto]);


    const confirmarVoto = () => {
        swal({
            title: `Seguro/a que desea votar por ${nombres} ${apellidos}?`,
            text: "Una vez haya votado, no podrá cambiar su voto.",
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"]
        }).then((respuesta) => {
            
            if (respuesta) {
                let voto = {
                    encuestaId: encuestaId,
                    participanteId: participanteId,
                    empleadoId: usuario
                }
                dispatch(fetchEfectuarVoto(voto))
                .then(() => {
                    dispatch(fetchVerificarVoto(voto))
                    swal({
                        title: "Voto registrado",
                        text: "Su voto ha sido efectuado con éxito.",
                        icon: "success",
                        button: "Aceptar"
                    })
                })
                .catch(() => {
                    swal({
                        title: "Error",
                        text: "Ocurrió un problema al registrar su voto. Intente nuevamente.",
                        icon: "error",
                        button: "Aceptar"
                    });
                });

            }
        })
    };

    return (
        <Card sx={{ width: 345, display: 'flex', flexDirection: 'column', height: '100%', border: participanteId === usuarioVotado ? '2px solid #003876' : 'none'}}>
            <Box sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex', mt: 2 }}>
                <Avatar
                    sx={{
                        width: 80,
                        height: 80,
                        border: 'solid',
                        borderWidth: 0.5,
                        borderColor: '#003876',
                    }}
                    src={fotoEmpleado}
                />
            </Box>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography gutterBottom variant="h6" component="div" textAlign={'center'}>
                    {nombres} {apellidos}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }} textAlign={'center'}>
                    {areaOrganizacional}
                </Typography>
            </CardContent>
            <Box sx={{ flexGrow: 1 }} />
            <CardActions sx={{ justifyContent: 'center' }}>
                <Button variant="contained" onClick={() => criteriosHabilitado ?  setOpenVotacionCriterios({ open: true, empleado: participante}) : confirmarVoto()} disabled={haVotado}>Votar</Button>
            </CardActions>
        </Card>

    );
}